const scrollTo = (position?: number) => {
  if (position) {
    window.scrollTo(0, position);
  } else {
    window.scrollTo(0, 0);
  }
};

export default scrollTo;
